import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Card } from "../../components/ui";

// Admin menu sections
const adminSections = [
  {
    title: "Onboarding",
    description: "Aggiungi nuove RSA e Fornitori al sistema",
    items: [
      {
        path: "/admin/rsa/nuovo",
        icon: "🏥",
        label: "Nuova RSA",
        description: "Registra una nuova Residenza Sanitaria Assistenziale",
      },
      {
        path: "/admin/fornitori/nuovo",
        icon: "🏢",
        label: "Nuovo Fornitore",
        description: "Registra un nuovo fornitore di servizi",
      },
      {
        path: "/admin/utenti/nuovo",
        icon: "👤",
        label: "Nuovo Utente Portale",
        description: "Crea un nuovo utente per accesso al portale",
      },
    ],
  },
  {
    title: "Configurazione Tipologie",
    description: "Gestisci le tipologie di fornitura, intervento e documenti",
    items: [
      {
        path: "/admin/tipologie-fornitura",
        icon: "📦",
        label: "Tipologie Fornitura",
        description: "Categorie di servizi offerti dai fornitori",
      },
      {
        path: "/admin/tipologie-intervento",
        icon: "🔧",
        label: "Tipologie Intervento",
        description: "Tipi di intervento manutentivo",
      },
      {
        path: "/admin/guide-autorisoluzione",
        icon: "💡",
        label: "Guide Autorisoluzione",
        description:
          "Guide passo-passo per risolvere problemi minori senza aprire una richiesta",
      },
      {
        path: "/admin/tipi-documento",
        icon: "📄",
        label: "Tipi Documento",
        description: "Gestisci i tipi di documento (OptionSet Dataverse)",
      },
      {
        path: "/admin/macrocategorie",
        icon: "🏷️",
        label: "Macrocategorie",
        description:
          "Gestisci le macrocategorie per tipologie intervento e fornitura",
      },
    ],
  },
  {
    title: "Valutazione Fornitori",
    description: "Configurazione sistema valutazione ISO 9001:2015",
    items: [
      {
        path: "/admin/criteri-valutazione",
        icon: "⭐",
        label: "Criteri Valutazione",
        description: "Gestisci il catalogo criteri per macrocategoria",
      },
      {
        path: "/admin/config-documenti-valutazione",
        icon: "📁",
        label: "Documenti Obbligatori",
        description:
          "Configura i tipi documento obbligatori per macrocategoria fornitore",
      },
      {
        path: "/valutazione-fornitori",
        icon: "📊",
        label: "Dashboard Valutazioni",
        description: "Panoramica valutazioni e creazione nuove schede",
      },
    ],
  },
  {
    title: "Relazioni e Associazioni",
    description: "Configura le associazioni tra entità",
    items: [
      {
        path: "/admin/associazioni/fornitore-rsa",
        icon: "🔗",
        label: "Fornitore ↔ RSA",
        description: "Associa fornitori alle RSA tramite contratti",
      },
      {
        path: "/admin/associazioni/fornitore-tipologie",
        icon: "⚙️",
        label: "Fornitore ↔ Tipologie",
        description: "Definisci quali interventi può fare ogni fornitore",
      },
      {
        path: "/admin/contratti/nuovo",
        icon: "📋",
        label: "Nuovo Contratto",
        description: "Crea un nuovo contratto fornitore-RSA",
      },
    ],
  },
  {
    title: "Documenti",
    description: "Gestione documenti e archivio SharePoint",
    items: [
      {
        path: "/admin/documenti",
        icon: "📁",
        label: "Archivio Documenti",
        description: "Gestisci i documenti caricati su SharePoint",
      },
      {
        path: "/admin/documenti/upload",
        icon: "📤",
        label: "Carica Documento",
        description: "Carica un nuovo documento",
      },
    ],
  },
  {
    title: "Notifiche",
    description: "Configurazione sistema notifiche email",
    items: [
      {
        path: "/admin/notifiche/configurazione",
        icon: "⚙️",
        label: "Configurazione Notifiche",
        description: "Imposta tempi e destinatari delle notifiche",
      },
      {
        path: "/admin/notifiche/invio",
        icon: "📧",
        label: "Invia Notifica",
        description: "Invia notifiche manuali o reminder",
      },
      {
        path: "/admin/notifiche/storico",
        icon: "📜",
        label: "Storico Invii",
        description: "Visualizza lo storico delle notifiche inviate",
      },
    ],
  },
  {
    title: "Utenti e Sistema",
    description: "Gestione utenti e configurazioni del portale",
    items: [
      {
        path: "/admin/utenti",
        icon: "👥",
        label: "Gestione Utenti",
        description: "Amministra gli utenti del portale",
      },
      {
        path: "/admin/configurazioni",
        icon: "🔧",
        label: "Configurazioni Sistema",
        description: "Impostazioni generali del portale",
      },
      {
        path: "/admin/email-mapping",
        icon: "📧",
        label: "Email Mapping",
        description: "Configura parsing automatico email fornitori",
      },
      {
        path: "/admin/integratori-api",
        icon: "🔌",
        label: "Integratori API",
        description:
          "Sistemi terzi che inviano rapportini per conto di piu' fornitori",
      },
      {
        path: "/admin/calendari",
        icon: "🗓️",
        label: "Calendari RSA",
        description: "Verifica e gestisci condivisioni calendari Outlook",
      },
      {
        path: "/admin/permessi-ruoli",
        icon: "🔐",
        label: "Permessi Ruoli",
        description: "Configura la visibilità delle sezioni per ogni ruolo",
      },
      {
        path: "/admin/pdf-templates",
        icon: "📄",
        label: "Template PDF Bollette",
        description: "Configura pattern estrazione dati da PDF bollette",
      },
    ],
  },
];

// Stats cards for admin dashboard
const statsCards = [
  { label: "RSA Attive", value: "14", icon: "🏥", color: "primary" },
  { label: "Fornitori", value: "46", icon: "🏢", color: "success" },
  { label: "Contratti Attivi", value: "0", icon: "📋", color: "warning" },
  { label: "Scadenze Prossime", value: "0", icon: "⏰", color: "danger" },
];

function AdminDashboardPage() {
  const { user } = useAuth();

  // Check admin permissions
  const isAdmin = user?.ruoloLabel === "Admin" || user?.ruolo === "Admin";
  const isRSPP = user?.ruoloLabel === "RSPP" || user?.ruolo === "RSPP";
  const hasAdminAccess = isAdmin || isRSPP;

  if (!hasAdminAccess) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <div className="text-4xl mb-4">🚫</div>
          <h2 className="text-xl font-semibold text-red-700 mb-2">
            Accesso Non Autorizzato
          </h2>
          <p className="text-red-600">
            Non hai i permessi necessari per accedere a questa sezione.
            <br />
            Contatta l'amministratore per richiedere l'accesso.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Pannello Amministrazione
        </h1>
        <p className="text-gray-500 mt-1">
          Gestione completa del sistema PHC Web Portal
        </p>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {statsCards.map((stat, index) => (
          <div
            key={index}
            className={`bg-white rounded-lg border p-4 flex items-center gap-4`}
          >
            <div className={`text-3xl`}>{stat.icon}</div>
            <div>
              <div className="text-2xl font-bold text-gray-900">
                {stat.value}
              </div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Admin Sections */}
      {adminSections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="space-y-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {section.title}
            </h2>
            <p className="text-sm text-gray-500">{section.description}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {section.items.map((item, itemIndex) => (
              <Link
                key={itemIndex}
                to={item.path}
                className="block bg-white rounded-lg border border-gray-200 p-4 hover:border-primary-500 hover:shadow-md transition-all group"
              >
                <div className="flex items-start gap-3">
                  <div className="text-2xl group-hover:scale-110 transition-transform">
                    {item.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-medium text-gray-900 group-hover:text-primary-600">
                      {item.label}
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                      {item.description}
                    </p>
                  </div>
                  <div className="text-gray-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all">
                    →
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}

      {/* Quick Actions */}
      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="font-semibold text-gray-900 mb-4">Azioni Rapide</h3>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/admin/rsa/nuovo"
            className="btn-primary inline-flex items-center gap-2"
          >
            <span>🏥</span> Aggiungi RSA
          </Link>
          <Link
            to="/admin/fornitori/nuovo"
            className="btn-primary inline-flex items-center gap-2"
          >
            <span>🏢</span> Aggiungi Fornitore
          </Link>
          <Link
            to="/admin/contratti/nuovo"
            className="btn-secondary inline-flex items-center gap-2"
          >
            <span>📋</span> Crea Contratto
          </Link>
          <Link
            to="/admin/notifiche/invio"
            className="btn-secondary inline-flex items-center gap-2"
          >
            <span>📧</span> Invia Notifica
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboardPage;
